import { forwardRef, useImperativeHandle, useRef } from 'react';

import { Tooltip } from '../../components/Tooltip';
import { Typography } from '../../theme';
import { StyledText } from './Text.style';
import { useTruncation } from './useTruncation';

export interface TextProps {
  children: string | React.ReactNode;
  color?: string;
  size: Typography.FontSize;
  className?: string;
  maxWidth?: number;
  truncate?: boolean | number;
  fontWeight?: string;
  fontFamily?: string;
  fontStyle?: string;
  showTooltip?: boolean;
  fontWidth?: string;
  id?: string;
  block?: boolean;
  textDecoration?: React.CSSProperties['textDecoration'];
}

export const Text = forwardRef<HTMLSpanElement, TextProps>(function Text(
  {
    size,
    children,
    className,
    color,
    maxWidth,
    truncate,
    fontFamily,
    fontWeight,
    fontStyle,
    fontWidth,
    showTooltip = false,
    id,
    block = true,
    textDecoration,
  },
  ref
) {
  const textRef = useRef<HTMLSpanElement>(null);

  useImperativeHandle(ref, () => textRef.current as HTMLSpanElement);

  const isTruncated = useTruncation(textRef, { truncate, children });

  return (
    <Tooltip text={children} visible={showTooltip && isTruncated}>
      <StyledText
        ref={textRef}
        className={className}
        id={id}
        $size={size}
        $color={color}
        $maxWidth={maxWidth}
        $truncate={truncate}
        $fontFamily={fontFamily}
        $fontWeight={fontWeight}
        $fontStyle={fontStyle}
        $fontWidth={fontWidth}
        $block={block}
        $textDecoration={textDecoration}
      >
        {children}
      </StyledText>
    </Tooltip>
  );
});
